import * as _ from 'lodash';
import './ceremonyDialog.less';
import { AuditEntry } from '../../../components/auditlog/auditlogComponent';
import { ceremonyStates } from '../../../objects/Ceremony';

/**
 * @typedef { import('../../../objects/Ceremony').Ceremony } Ceremony
 * @typedef { import('../../../server/ApiServer').ApiServer } ApiServer
 */

function getCeremonyStateText(ceremonyState) {
    switch (ceremonyState) {
        case ceremonyStates.none: return '';
        case ceremonyStates.created: return 'Ej rapporterad';
        case ceremonyStates.reported: return 'Rapporterad';
        case ceremonyStates.rejected: return 'Avslagen';
        case ceremonyStates.accepted: return 'Godkänd';
        default: return 'Okänd';
    }
}

angular.module("tromanWeb").controller('CeremonyDialogController', ['$q', 'tromanServer', 'ObjectCache', 'downloadService', '$scope', 'ceremonyId', 
    /**
     * @param {any} $q
     * @param {ApiServer} tromanServer
     * @param {any} ObjectCache
     * @param {any} downloadService
     * @param {any} $scope
     * @param {string} ceremonyId
     */
    function ($q, tromanServer, ObjectCache, downloadService, $scope, ceremonyId) {
        this.close = function () {
            $scope.$close();
        };
        $q.all({
            users: ObjectCache.getAllUsers(),
            ceremony: tromanServer.Ceremonies.getCeremony(ceremonyId),
        }).then(result => {
            /** @type {Ceremony} */
            this.ceremony = result.ceremony;
            this.status = getCeremonyStateText(this.ceremony.State);
            this.audit = AuditEntry.generateAudit(this.ceremony.AuditEntries, result.users);

        }).catch(err => {
            this.error = err;
        });

        this.close = function () {
            $scope.$close();
        };

        this.downloadAttachment = function (attachment) {
            tromanServer.Files.downloadAttachment(attachment.Id)
                .then(rsp => downloadService.downloadBlob(rsp.blob, rsp.filename));
        };
    }
]);
